import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/payroll/viewPayroll";
import LeftArrow from "../../assets/LeftArrow";
import ModalComponent from "../../components/modals/ModalComponent";
import {
  ExportPayrollApi,
  GetPayrollData,
  uploadPayrollDoc,
  ViewPayrollHistoryApi,
} from "../../api/request/payroll/payroll";

import moment from "moment";
import addPayrollColumns from "../../columns/payroll/empViewHistory";
import { ReactComponent as Email } from "../../assets/email.svg";
import { ReactComponent as User } from "../../assets/User.svg";
import { ReactComponent as Phone } from "../../assets/phone.svg";
import { Button, Form, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import LoadableButton from "../../components/button/LoadableButton";
import UserAvatar from "../../components/common/UserAvatar";
import { saveAs } from "file-saver";
import View from "../../assets/View";
import GlobalTooltip from "../../components/common/GlobalTooltip";
import Export from "../../assets/Export";

const ViewPayRoll = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [completeStatusForm] = Form?.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [docOpen, setDocOpen] = useState(false);
  const [docUrl, setDocUrl] = useState([]);
  const [employeeHistory, setEmployeeHistory] = useState([]);
  const [isEmpHistoryLoading, setIsEmpHistoryLoading] = useState(false);
  const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
  const [isCompleteStatus, setIsCompleteStatus] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [selectValues, setSelectValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [fileList, setFileList] = useState([]);
  const { state } = useLocation();


  const getViewPayrollData = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetPayrollData({ client_id: id });

      if (data?.status) {
        setData(
          data?.data?.map((item) => ({
            ...item,
            start_date: moment(item?.start_date).format("ll"),
            end_date: moment(item?.end_date).format("ll"),
            status:
              item?.status === "pending" ? (
                <Select
                  value={selectValues[item?.id] || "pending"}
                  options={[
                    { label: "Pending", value: "pending" },
                    { label: "Entered", value: "entered" },
                  ]}
                  onChange={(value) => handleStatusChange(item, value)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: 120 }}
                />
              ) : (
                <p
                  className={`font-bold uppercase ${item?.status === "entered"
                    ? "text-green-500"
                    : "text-red-500"
                    }`}
                >
                  {item?.status}
                </p>
              ),
            doc: (
              <div
                className={`${item?.documents?.length
                  ? "text-blue-500 underline cursor-pointer"
                  : ""
                  }`}
                onClick={() => {
                  if (item?.documents?.length === 1) {
                    window.open(item?.documents[0]?.path, "_blank");
                  } else if (item?.documents?.length > 1) {
                    setDocUrl(item?.documents);
                    setDocOpen(true);
                  }
                }}
              >
                {item?.documents?.length ? "View Document" : "--"}
              </div>
            ),
            completed_by_user: (

              item?.completed_by_user
                ?
                <UserAvatar
                  data={{
                    name: item?.completed_by_user?.name,
                    email: item?.completed_by_user?.email,
                    profile_image: item?.profile_image,
                  }}
                />
                :
                '--'
            ),
            action: (
              <div className="flex gap-3">
                <GlobalTooltip title="View Payroll Employee History">
                  <button
                    onClick={() => {
                      setIsEmployeeModalOpen(true);
                      handleViewHistory(item);
                    }}
                  >
                    <View />
                  </button>
                </GlobalTooltip>
                <GlobalTooltip title="Export Payroll">
                  <button
                    onClick={() => {
                      handleExportPayroll(item?.id);
                    }}
                  >
                    <Export />
                  </button>
                </GlobalTooltip>
              </div>
            ),
          }))
        );
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };


  const handleConfirmStatusChange = async () => {
    if (!fileList.length) {
      toast.error("Please upload a PDF file");
      return;
    }

    try {
      setIsStatusLoading(true);

      const formData = new FormData();
      formData.append("payroll_id", selectedRow?.id);
      for (let i = 0; i < fileList.length; i++) {
        const element = fileList[i]?.originFileObj;
        formData.append("document[]", element); // <-- real File object
      }

      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await uploadPayrollDoc(formData, apiHeader);
      if (data?.status) {
        getViewPayrollData();
        toast.success(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Upload failed");
    } finally {
      setIsStatusLoading(false);
      setIsCompleteStatus(false);
      setSelectedRow(null);
      setFileList([]);
    }
  };

  const handleStatusChange = (row, newValue) => {
    setSelectValues((prev) => ({
      ...prev,
      [row?.id]: newValue,
    }));

    setSelectedStatus(newValue);
    setSelectedRow(row);
    if (newValue === "entered") {
      setIsCompleteStatus(true);
    }
  };

  const handleCancelStatusChange = () => {
    setSelectValues((prev) => ({
      ...prev,
      [selectedRow?.id]: selectedRow?.status,
    }));
    setIsCompleteStatus(false);
    setSelectedStatus(null);
  };

  const handleViewHistory = async (EmpData) => {
    if (!EmpData?.id) return;
    try {
      setIsEmpHistoryLoading(true);
      const { data } = await ViewPayrollHistoryApi({ id: EmpData?.id });
      if (data?.status) {
        setEmployeeHistory(
          data?.data[0]?.payroll_data?.map((item) => {
            return {
              ...item,
              email: (
                <div>
                  <p className="flex items-center">
                    <Email className="mr-1 size-3" />
                    {item?.email || "--"}
                  </p>
                  <p className="flex items-center">
                    <Phone className="mr-1 size-3" />
                    {item?.contact_no || "--"}
                  </p>
                </div>
              ),
            };
          }) || []
        );
      }
    } catch (error) {
      toast?.error(error?.response?.data?.message);
    } finally {
      setIsEmpHistoryLoading(false);
    }
  };
  const handleExportPayroll = async (payrollId) => {
    try {

      setIsLoading(true);
      const headers = { responseType: "arraybuffer" };
      const res = await ExportPayrollApi({ client_id: id, id: payrollId }, headers);

      const blob = new Blob([res?.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });


      const fileName = "PayrollData.xlsx";
      saveAs(blob, fileName);
    } catch (error) {
      const msg = error?.response?.data?.error || "Failed to download file";
      toast?.error(msg);
    } finally {
      setIsLoading(false);
    }
  };
  const docColumns = [
    {
      title: "Document Name",
      dataIndex: "original_name",
      render: (value) => value || "--",
    },
    {
      title: "Action",
      dataIndex: "path",
      render: (path) => (
        <p
          onClick={() => window.open(path, "_blank")}
          className="text-blue-500 underline cursor-pointer"
        >
          View
        </p>
      ),
    },
  ];

  useEffect(() => {
    getViewPayrollData();
  }, []);

  const { name, email } = state?.client || {};

  return (
    <>
      <div className="border rounded-xl bg-white">
        <div className="flex items-center justify-between gap-3 mx-5">
          <div className="flex gap-3">
            <button
              onClick={() => navigate('/payroll')}
              className="text-secondary"
            >
              <LeftArrow />
            </button>
            <p className="title">
              Client Payroll Records {data?.length ? `(${data?.length})` : ""}
            </p>
          </div>
          <div className="flex items-center">
            {/* <LoadableButton
              onClick={() => handleExportPayroll()}
              isLoading={exportLoading}
              loadingLable="Exporting Payroll"
              className="h-fit"
            >
              <UploadFile /> Export Payroll
            </LoadableButton> */}
            <div className="flex items-center space-x-3">
              <div className="mx-5 my-5">
                <p className="text-sm text-gray-600 flex items-center mb-1">
                  <User className="mr-1 size-5" /> {name}
                </p>
                <p className="text-sm text-gray-600 flex items-center">
                  <Email className="mr-1 size-5" /> {email}
                </p>
              </div>
            </div>


          </div>
        </div>


        <SkeletonTable columns={columns} data={data} isLoading={isLoading} pagination={true} />

        <ModalComponent
          isOpen={docOpen}
          setIsOpen={setDocOpen}
          title="View Document"
        >
          <SkeletonTable
            columns={docColumns}
            data={docUrl || []}
            pagination={false}
          />
        </ModalComponent>


        <ModalComponent
          isOpen={isEmployeeModalOpen}
          setIsOpen={setIsEmployeeModalOpen}
          title={
            <div>
              <p>View Payroll Employee History</p>
              <p className="text-base text-gray-500">
                [ {data[0]?.start_date} to {data[0]?.end_date} ]
              </p>
            </div>
          }
          width="60%"
        >
          <SkeletonTable
            rowKey="payroll_emp_id"
            columns={addPayrollColumns(setEmployeeHistory)}
            data={employeeHistory || []}
            isLoading={isEmpHistoryLoading}
          />

        </ModalComponent>
        <ModalComponent
          isOpen={isCompleteStatus}
          setIsOpen={setIsCompleteStatus}
          onCancel={handleCancelStatusChange}
          title="Add Completion Document"
        >
          <div className="flex flex-col gap-4 mt-4 items-center w-full">
            <Form
              form={completeStatusForm}
              layout="vertical"
              className="w-full"
              onFinish={handleConfirmStatusChange}
            >
              <Form.Item
                label="Completion Document"
                name="completion_document"
                rules={[{ required: true, message: "Please upload a PDF" }]}
              >
                <Upload
                  multiple
                  fileList={fileList}
                  onChange={({ fileList }) => setFileList(fileList)}
                  beforeUpload={() => false} // prevent auto upload
                  accept="application/pdf"
                // maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
              </Form.Item>



              <LoadableButton
                type="submit"
                lable="Submit"
                isLoading={isStatusLoading}
                loadingLable="Submitting..."
              />
            </Form>
          </div>
        </ModalComponent>
      </div>
    </>
  );
};

export default ViewPayRoll;
